module.exports = __webpack_public_path__ + "static/media/2fa-google.839a36ac.svg";